import {createPhonePrefixAdapter} from '../adapters/phones.adapter';
import flags from '../util/countries';

export function getPhonePrefixes () {
  const lang = (window.navigator.language).split("-");
  const language = lang[0];
  return flags.map(entry => createPhonePrefixAdapter(entry.code, entry.translations[language], entry.dial_code)).sort((first_entry, last_entry) => (first_entry.text > last_entry.text) ? 1 : -1);
}